import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('cookies');
export const actions = helper.createActions('cookies', actionTypes);